import React, { Component, Fragment } from 'react';
import {
  borderColor,
  navigationTabContentStretchedWrapperHeight,
  heightOfInformationBox,
  isDevelopment
} from '../../../library/constants';
import { Notifications } from './Notifications';
import FlipdataContent from '../FlipdataContent_class';
import ImmediateFamilySection from '../ImmediateFamilySection';

import { EntryForm } from '../../InviteModal';

// let scrollTop = 0;
// let nodeForFlipFocus = 0;
export class Description extends Component {


  componentDidMount(){
    // console.log('Description/componentDidMount');
    // console.log(`{this.props.nodeForFlipFocus, }: `, JSON.stringify({1:this.props.nodeForFlipFocus, 2:nodeForFlipFocus}, null, 2));
  }


  componentDidUpdate (prevProps, prevState, snapshot){

    // if( !isDevelopment) document.getElementById("descriptionBox").scrollTop = ( nodeForFlipFocus !== this.props.nodeForFlipFocus ? 0: scrollTop);

  }

  showEmailInvite(){
    const nodeObj = this.props.nodeObjs[this.props.nodeForFlipFocus];
    const bool = typeof(nodeObj.g_e) !== 'undefined' && parseInt(nodeObj.g_e, 10) === 1;
    return bool;
  }

  render () {

    if( typeof(this.props.nodeForFlipFocus) === 'undefined'  ) return null

    // console.log('Description/render');

    const {
      flipData,
      canvasHeight,
      translatedLabels,
      addNodeFormFocus,
      nodeObjs,
      fetchIsLoading,
      openAddNodeForm,
      clickforImmediateFamily,
      setPedigreeAddbox,
      isPedigree,
      navigationPanelIsUp,
      canChangeDifferentParent,
      postChosenUnionId,
    } = this.props;

    let heightOfDescriptionBox = (canvasHeight - 350) - ( navigationPanelIsUp ? (navigationTabContentStretchedWrapperHeight  + 10) : 6 )
    if(this.props.chartType === 'fan') heightOfDescriptionBox = heightOfDescriptionBox - heightOfInformationBox
    let heightOfDescriptionBoxStr = `${heightOfDescriptionBox}px`;

    const descriptionBoxStyle = {
                overflowX: 'hidden',
                overflowY: 'scroll',
                height: heightOfDescriptionBox,
                width: `100%`,
                margin: '0px 0px 0px 0px',
                padding: '10px',
                clear: `both`,
                position: `relative`,
                top: `50px`,
                border: '1px solid',
                borderColor: borderColor,
                boxSizing: 'border-box',
                opacity: ( fetchIsLoading ? .6 : 1),
                // background: 'red',
              }

    if( !isDevelopment){

      if(typeof(flipData) === 'undefined' || flipData === null){
        return (
          <div  id= "descriptionBox"
                style={{
                  width: `100%`,
                  height: heightOfDescriptionBoxStr,
                  clear: `both`,
                  position: `relative`,
                  top: `50px`,
                  float: 'left',
                  border: `1px solid ${borderColor}`,
                }}
            >
          </div>
        )
      }
    }

    return (
        <div  id= "descriptionBox"
              style={descriptionBoxStyle}
              onScroll={()=>{
                // scrollTop = document.getElementById("descriptionBox").scrollTop;
                // console.log(`scrollTop: `, scrollTop);
              }
            }
        >
          {

            fetchIsLoading

              ?

            null

              :

            <Fragment>

                <Notifications
                  {...this.props }
                />
                {

                  this.showEmailInvite()

                  ?

                    <EntryForm
                      {...this.props}
                      fromSidePanel={true}
                      nodeObjs={this.props.nodeObjs}
                      chartType={this.props.chartType}
                    />

                  :

                  null

                }

                <div style={{
                        width: `100%`,
                        height: '25px',
                        fontWeight: 'bold',
                        fontSize: '15px',
                        color: '#636363',
                        // background: 'red',
                        textDecoration: 'underline',
                      }}
                >
                  {translatedLabels[`Profile Details`].translatedLabel}
                </div>
                <FlipdataContent
                  flipData={flipData}
                  translatedLabels={translatedLabels}
                />
                <div style={{
                  height: '2px',
                  width: `100%`,
                  marginTop: '25px',
                }}
                >
                </div>
                <ImmediateFamilySection
                  {
                    ...{
                      addNodeFormFocus,
                      nodeObjs,
                    }
                  }
                  translatedLabels={translatedLabels}
                  immediateFamVersion={'flipPanel'}
                  nodeObj={nodeObjs[addNodeFormFocus]}
                  openAddNodeForm={openAddNodeForm}
                  canChangeDifferentParent={canChangeDifferentParent}
                  postChosenUnionId={postChosenUnionId}
                  clickforImmediateFamily={clickforImmediateFamily}
                  isPedigree={isPedigree}
                  setPedigreeAddbox={setPedigreeAddbox}
                />
            </Fragment>


            }

        </div>
    )
  }
};


/*
Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
 */


